import { media, styled } from '@styles';

export const Wrapper = styled.div`
  width: 63vw;
  max-width: 1200px;
  margin: 0 auto;

  ${media.largeScreen`
    max-width: 860px;
    width: 72vw;
  `}
  ${media.mediumScreen`
    max-width: 640px;
    width: 85vw;
  `}

  img {
    width: 100%;
  }
`;
